import styled from 'styled-components';

export const ConnectorCardStyled = styled.div`
  background: var(--color-white);
  width: 16.8rem;
  border-radius: 6px;
  min-block-size: 20.1rem;
`;
